import React from "react";

import type { UserType } from "../../auth/authApi";

/**
 * Rótulos dos tipos de usuário do sistema (seis desde 04/10/2026: Financeiro e
 * Financeiro leitura, ADR 0024; sete desde 11/10/2026: Admin restrito, ADR 0027).
 *
 * O badge do `EditUserModal` antigo só conhecia `ADMIN` e `SUPERVISOR`, e caía
 * no rótulo "Campo" para qualquer outro valor — então `DP` aparecia como
 * "Campo" (parte do BUG-008). Aqui todos são explícitos e um valor
 * desconhecido é exibido como veio, em vez de virar outro tipo.
 */
export const USER_TYPE_LABELS: Record<UserType, string> = {
  ADMIN: "Admin",
  ADMIN_RESTRITO: "Admin restrito",
  SUPERVISOR: "Supervisor",
  SUPERVISOR_DE_CAMPO: "Campo",
  DP: "Dep. Pessoal",
  FINANCEIRO: "Financeiro",
  FINANCEIRO_LEITURA: "Financeiro (leitura)",
  GESTOR_CAMPANHAS: "Campanhas",
};

const CORES: Record<UserType, string> = {
  ADMIN: "admBadge--red",
  ADMIN_RESTRITO: "admBadge--red",
  SUPERVISOR: "admBadge--blue",
  SUPERVISOR_DE_CAMPO: "admBadge--orange",
  DP: "admBadge--green",
  FINANCEIRO: "admBadge--purple",
  FINANCEIRO_LEITURA: "admBadge--gray",
  GESTOR_CAMPANHAS: "admBadge--purple",
};

export const userTypeLabel = (userType: string): string =>
  USER_TYPE_LABELS[userType as UserType] ?? userType;

type Props = { userType: string };

const UserTypeBadge: React.FC<Props> = ({ userType }) => (
  <span className={`admBadge ${CORES[userType as UserType] ?? "admBadge--gray"}`}>
    {userTypeLabel(userType)}
  </span>
);

export default UserTypeBadge;
